import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { COMPLEXIDADE_SENHA } from '~/constants/modules';
import { can } from '~/helpers';
import { dataInRequest, findData } from '~/store/modules/clienteConfig/actions';

import MyForm from './form';

function ClienteConfig() {
  const redux = useSelector((state) => state.clienteConfig);

  const formaidfrentista = useMemo(
    () => [
      { label: 0, value: 'Não solicita frentista' },
      { label: 1, value: 'Solicita código do frentista' },
      { label: 3, value: 'Solicita código/senha do frentista' },
      { label: 4, value: 'Solicita TAG do frentista' },
      { label: 5, value: 'Solicita código OU TAG do frentista' },
      { label: 7, value: 'Solicita código/senha OU TAG do frentista' },
      { label: 12, value: 'Solicita TAG/senha do frentista' },
      { label: 15, value: 'Solicita código/senha ou TAG/senha do frentista' },
    ],
    []
  );

  const formaidmotorista = useMemo(
    () => [
      { label: 0, value: 'Não solicita motorista' },
      { label: 1, value: 'Solicita apenas o codigo para qualquer veículo' },
      { label: 2, value: 'Solicita codigo e senha para qualquer veículo' },
      { label: 3, value: 'Solicita apenas o codigo para veículos prórios' },
      { label: 4, value: 'Solicita codigo e senha para veículos prórios' },
      { label: 5, value: 'Solicita apenas o codigo para veículos terceiros' },
      { label: 6, value: 'Solicita codigo e senha para veículos terceiros' },
    ],
    []
  );

  const sn = useMemo(
    () => [
      { label: 0, value: 'Não' },
      { label: 1, value: 'Sim' },
    ],
    []
  );

  const juntaAbastecimentoSequencial = useMemo(
    () => [
      { label: 0, value: 'Não realizar a junção' },
      {
        label: 1,
        value: 'Realizar junção com atraso na disponibilização para integração',
      },
      {
        label: 2,
        value: 'Realizar junção com retransmissão para integração',
      },
    ],
    []
  );

  const snretricaotag = useMemo(
    () => [
      {
        label: 0,
        value: 'Não utiliza controle de restricao tag',
      },
      {
        label: 1,
        value: 'Utiliza e não permite reutilização das tags',
      },
      { label: 2, value: 'Utiliza e permite a reutilização de tags' },
    ],
    []
  );

  const strsn = useMemo(
    () => [
      { label: 'N', value: 'Não' },
      { label: 'S', value: 'Sim' },
    ],
    []
  );

  const strsnCampoLivreMudaModo = useMemo(
    () => [
      { label: 'N', value: 'Não' },
      { label: 'S', value: 'Sim' },
    ],
    []
  );

  const formadigitacaofrota = useMemo(
    () => [
      { label: 0, value: '' },
      { label: 1, value: 'Conforme cadastro do veículo' },
    ],
    []
  );

  const ativaloginazure = useMemo(
    () =>
      can(COMPLEXIDADE_SENHA)
        ? [{ label: 'N', value: 'SCA+' }]
        : [
            { label: 'N', value: 'SCA+' },
            { label: 'S', value: 'Azure' },
          ],
    []
  );

  const exibebloqtngveicclienteconfig = useMemo(
    () => [
      { label: 'N', value: 'Não' },
      { label: 'S', value: 'Sim' },
    ],
    []
  );

  const header = useMemo(() => {
    const data = [
      {
        id: 'idcliente',
        label: 'Código Cliente',
        filter: { type: 'text' },
      },
      {
        id: 'formaidfrentistaclienteconfig',
        label: 'Forma ID Frentista',
        formatted: (value) =>
          formaidfrentista.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: formaidfrentista },
      },
      {
        id: 'formaidfrentistaabastclienteconfig',
        label: 'Forma ID Frentista Abastecimento',
        formatted: (value) =>
          formaidfrentista.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: formaidfrentista },
      },
      {
        id: 'formaidmotoristaclienteconfig',
        label: 'Forma ID Motorista',
        formatted: (value) =>
          formaidmotorista.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: formaidmotorista },
      },
      {
        id: 'formaidcentrocusto',
        label: 'Solicita Centro de Custo no terminal',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'confirmatotrodadoclienteconfig',
        label: 'Solicita confirmação totalizador rotado no terminal',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'logdvecclienteconfig',
        label: 'Log irregularidade DBIC',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'solicitacampolivremudamodoclienteconfig',
        label: 'Solicita campo livre ao mudar modo',
        formatted: (value) =>
          strsnCampoLivreMudaModo.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: strsnCampoLivreMudaModo },
      },
      {
        id: 'acoesirregularidadedbicclienteconfig',
        label: 'Bloqueia bico irregularidade DBIC',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'dbic4bloqueiaveiculoclienteconfig',
        label: 'Bloqueia veículo irregularidade DBIC',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'dbic4bloqueiafrentistaclienteconfig',
        label: 'Bloqueia frentista irregularidade DBIC',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'maximoerrosinclinacaodbicclienteconfig',
        label: 'Qtd. erros DBIC para bloqueio',
        filter: { type: 'number' },
      },
      {
        id: 'percentualcompartimentoclienteconfig',
        label: 'Percentual compartimento cheio lubrificação',
        filter: { type: 'number' },
      },
      {
        id: 'juntaabastsequencialclienteconfig',
        label: 'Junta abastecimentos em sequência',
        formatted: (value) =>
          juntaAbastecimentoSequencial.find((s) => s.label === value)
            ?.value || '',
        filter: { type: 'select', options: juntaAbastecimentoSequencial },
      },
      {
        id: 'diacortecotaclienteconfig',
        label: 'Dia corte controle cotas',
        filter: { type: 'number' },
      },
      {
        id: 'grupotanqueclienteconfig',
        label: 'Controla grupo de tanques',
        formatted: (value) => strsn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: strsn },
      },
      {
        id: 'exibeosclienteconfig',
        label: 'Solicita OS no terminal',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'formadigitacaofrotaclienteconfig',
        label: 'Digitação de frota na liberação de abastecimento',
        formatted: (value) =>
          formadigitacaofrota.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: formadigitacaofrota },
      },
      {
        id: 'leitortagfrentistaclienteconfig',
        label: 'Leitor cartão frentista',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'leitortagmotoristaclienteconfig',
        label: 'Leitor cartão motorista',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'kmdvecsolicitadigitacaoclienteconfig',
        label: 'Km para solicitação de digitação DVEC',
        filter: { type: 'number' },
      },
      {
        id: 'horadvecsolicitadigitacaoclienteconfig',
        label: 'Tempo para solicitação de digitação DVEC',
        filter: { type: 'number' },
      },
      {
        id: 'varmaxfatorafericaodvec',
        label: 'Variação máxima do fator de aferição DVEC',
        filter: { type: 'number' },
      },
      {
        id: 'kmdvecpulsoentraafericaoclienteconfig',
        label: 'Km para DVEC sinal entrar em aferição',
        filter: { type: 'number' },
      },
      {
        id: 'kmdveccanparcialentraafericaoclienteconfig',
        label: 'Km para DVEC parcial entrar em aferição',
        filter: { type: 'number' },
      },
      {
        id: 'horadvecentraafericaoclienteconfig',
        label: 'Tempo para DVEC entrar em aferição',
        filter: { type: 'number' },
      },
      {
        id: 'associadvecentradaautoafericaodvechorimentoclienteconfig',
        label: 'Associa DVEC automaticamente na entrada da aferição',
        formatted: (value) => strsn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: strsn },
      },
      {
        id: 'controlarestricaotag',
        label: 'Controla restrição de TAG',
        formatted: (value) =>
          snretricaotag.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: snretricaotag },
      },
      {
        id: 'exibebloqtngveicclienteconfig',
        label: 'Bloqueia abastecimento acima da capacidade do tanque',
        formatted: (value) =>
          exibebloqtngveicclienteconfig.find((s) => s.label === value).value ||
          '',
        filter: { type: 'select', options: exibebloqtngveicclienteconfig }, // strn
      },
      {
        id: 'descontaabastclienteconfig',
        label: 'Desconta Abastecimento',
        formatted: (value) => sn.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: sn },
      },
      {
        id: 'ativaloginazureclienteconfig',
        label: 'Tipo de login',
        formatted: (value) =>
          ativaloginazure.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: ativaloginazure },
      },
      {
        id: 'azureclientidclienteconfig',
        label: 'Client ID',
        filter: { type: 'text' },
      },
      {
        id: 'azuretenandidclienteconfig',
        label: 'Tenant ID',
        filter: { type: 'text' },
      },
      {
        id: 'azureresponsetypeclienteconfig',
        label: 'Response Type',
        filter: { type: 'text' },
      },
      {
        id: 'azureresponsemodeclienteconfig',
        label: 'Response Mode',
        filter: { type: 'text' },
      },
      {
        id: 'azurescopeclienteconfig',
        label: 'Scope',
        filter: { type: 'text' },
      },
      {
        id: 'azureredirecturiclienteconfig',
        label: 'Redirect URL',
        filter: { type: 'text' },
      },
      {
        id: 'tokensstelematicaclienteconfig',
        label: 'Token SS Telemática',
        filter: { type: 'text' },
      },
    ];
    return data;
  }, [
    formaidfrentista,
    formaidmotorista,
    sn,
    juntaAbastecimentoSequencial,
    strsn,
    strsnCampoLivreMudaModo,
    formadigitacaofrota,
    ativaloginazure,
    snretricaotag,
    exibebloqtngveicclienteconfig,
  ]);

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={dataInRequest}
      find={findData}
      form={MyForm}
      keys="idcliente"
      detach="idcliente"
    />
  );
}

export default ClienteConfig;
